<template>
    <div class="bameiHome">
       <Header :tabList="tabList" @change="onTabChange" @lang="onLanChane" 
       :isEnglish="isEnglish" 
       :Selectlanguage="Selectlanguage"
       :value="selectValue" v-if="isshowHeader"></Header>
       <Header2 :tabList="tabList" @change="onTabChange" @lang="onLanChane" 
       :isEnglish="isEnglish" 
       :Selectlanguage="Selectlanguage"
       :value="selectValue" v-else></Header2>
       <router-view></router-view>
       <Footer ></Footer>
    </div>
</template>
<script>
import { mapState } from "vuex";
import Header from "../bamei/components/header";
import Header2 from "../bamei/components/header2";
import Footer from "../bamei/components/footer";
export default {
    components: {
    Header,
    Header2,
    Footer
  },
   provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      tabList: [
           {
          label: "首页",
          value: "home",
          routeName: "bameiHomePage",
          path: "/index"
        },
        {
          label: "景区介绍",
          value: "introduce",
          routeName: "bameiintroduce",
          path: "/strategy"
        },
         {
          label: "游玩攻略",
          value: "strage",
          routeName: "bameistrategy",
          path: "/bmstrategy"
        },
         {
          label: "最新资讯",
          value: "news",
          routeName: "bameinewslist",
          path: "/newslist"
        },
        {
          label: "景区门票",
          value: "ticket",
          routeName: "bameiTicketlist",
          path: "/ticketlist"
        }
       
      ],
      selectValue:'bameiHomePage',
      isshowHeader:true,
      ticketList: [],
      shopList: [],
      isEnglish:false,
      Selectlanguage:'chinese'
    };
  },
   computed: {
    ...mapState("privateConfig", ["pageWidth"])
  },
 
   watch: {
    $route(val) {
      
     if(val.path.includes('index')){
      this.isshowHeader=true;
      localStorage.setItem('selectValue','bameiHomePage')
      }else{
        this.isshowHeader=false;
      }
    this.selectValue=localStorage.getItem('selectValue');
    
    }
  },
  
  methods: {
     reload() {
      this.isRouterAlive = false;
      //在修改数据之后使用 $nextTick，则可以在回调中获取更新后的 DOM
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    onTabChange(data) {
      
      this.selectValue=data.routeName;
      localStorage.setItem('selectValue',data.routeName);
     if(!window.location.href.includes('/index')){
      this.isshowHeader=false;
    }else{
       this.isshowHeader=true;
    } 
    
    if(data.routeName==='bameistrategy'){
       localStorage.setItem('news_title','游玩攻略')
      this.$router.push("/bmstrategy?m_id="+ this.$route.query.m_id + "&pid=615");
    }else if(data.routeName==='bameinewslist'){
      localStorage.setItem('news_title','最新资讯')
        this.$router.push(
         "/newslist?m_id=" + this.$route.query.m_id + "&pid=616"
        );
    }else if(data.routeName==='bameiintroduce'){
      
        this.$router.push(
         "/introduce?m_id=" + this.$route.query.m_id +"&pid=1493&menuId=613"
        );
      }else{
      this.$router.push({
        name: data.routeName
      });
    }
    
    },
    onLanChane(type){
        if(type==='chinese'){
          this.isEnglish=false;
        }
        if(type==='English'){
          this.isEnglish=true;

        }
        this.Selectlanguage=type;
    }
  }
}
</script>
<style scoped>
  .bameiHome{
    width: 100%;
    overflow: hidden;
    background: #f7f7f7;
  }
</style>


// WEBPACK FOOTER //
// src/pages/bamei/index.vue